import { Typography } from '@mui/material';
import Slider from '@mui/material/Slider';
import React, { useEffect, useRef, useState } from 'react';
// import { PauseBlackButtonNew, PlayBlackButtonNew } from '../../assets/images'; 
import { MuiStack } from '../../components';
import { gray } from '../../theme/palette';
import { systemColor } from '../../theme/systemColor';
import { PauseBlackButtonNewSVG, PlayBlackButtonNewSVG } from '../../assets/customIcons';
export var AudioPlayer = function (_ref) {
    var src = _ref.src, isSlider = _ref.isSlider, isAudioPlay = _ref.isAudioPlay, audioDuration = _ref.audioDuration, audioBgColor = _ref.audioBgColor;
    var audioRef = useRef();
    var audio = new Audio(src);
    var _a = useState(false), isPlaying = _a[0], setIsPlaying = _a[1];
    var _b = useState(0), currentTime = _b[0], setCurrentTime = _b[1];
    var _c = useState(0), duration = _c[0], setDuration = _c[1];
    var _d = useState(false), showFullAudioLength = _d[0], setShowFullAudiolength = _d[1];
    var getDuration = function () {
        audio.currentTime = 0;
        audio.removeEventListener('timeupdate', getDuration);
        setDuration(audio.duration);
    };
    useEffect(function () {
        if (src) {
            audio.currentTime = 1e101;
            audio.addEventListener('loadedmetadata', function () {
                if ((audio === null || audio === void 0 ? void 0 : audio.duration) === Infinity || isNaN(Number(audio.duration)) || audio !== null && audio !== void 0 && audio.duration) {
                    setDuration(audio.duration);
                    audio.addEventListener('timeupdate', getDuration);
                }
            });
        }
    }, [src]);
    useEffect(function () {
        var audioElement = audioRef.current;
        var handleTimeUpdate = function () {
            if (audioElement) {
                setCurrentTime(audioElement.currentTime);
            }
        };
        var handleEnded = function () {
            setCurrentTime(0);
            setIsPlaying(false);
            setShowFullAudiolength(false);
        };
        audioElement === null || audioElement === void 0 || audioElement.addEventListener('timeupdate', handleTimeUpdate);
        // audioElement?.addEventListener('loadedmetadata', handleLoadedMetadata);
        audioElement === null || audioElement === void 0 || audioElement.addEventListener('ended', handleEnded);
        return function () {
            audioElement === null || audioElement === void 0 || audioElement.removeEventListener('timeupdate', handleTimeUpdate);
            // audioElement?.removeEventListener('loadedmetadata', handleLoadedMetadata);
            audioElement === null || audioElement === void 0 || audioElement.addEventListener('ended', handleEnded);
        };
    }, []);
    var playPauseHandler = function () {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
            }
            else {
                audioRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };
    var seekHandler = function (_event, newValue) {
        if (audioRef.current) {
            var newTime = typeof newValue === 'number' && isFinite(newValue) ? newValue : 0;
            audioRef.current.currentTime = newTime;
            setCurrentTime(newTime);
        }
    };
    function formatTime(seconds) {
        var minutes = Math.floor(seconds / 60);
        var remainingSeconds = Math.floor(seconds % 60);
        return "".concat(String(minutes).padStart(2, '0'), ":").concat(String(remainingSeconds).padStart(2, '0'));
    }
    var handleTimeFinder = function () {
        setShowFullAudiolength(true);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("audio", {
        ref: audioRef
    }, /*#__PURE__*/ React.createElement("source", {
        src: src,
        type: "audio/mpeg"
    }), /*#__PURE__*/ React.createElement("source", {
        src: src,
        type: "audio/ogg"
    }), /*#__PURE__*/ React.createElement("source", {
        src: src,
        type: "audio/wav"
    }), /*#__PURE__*/ React.createElement("source", {
        src: src,
        type: "audio/mp4"
    }), /*#__PURE__*/ React.createElement("source", {
        src: src,
        type: "audio/webm"
    }), "Your browser does not support the audio element."), /*#__PURE__*/ React.createElement(MuiStack, {
        id: "audio",
        alignItems: 'center',
        spacing: 1.5,
        justifyContent: 'space-between',
        width: '100%',
        bgcolor: audioBgColor
    }, isPlaying ? /*#__PURE__*/ React.createElement(PauseBlackButtonNewSVG, {
        id: "audio-pause-click",
        sx: {
            height: isAudioPlay ? "36px" : "36px",
            width: isAudioPlay ? "36px" : "36px",
            color: systemColor.primary,
            marginLeft: '12px'
        },
        onClick: function () {
            playPauseHandler();
        }
    }) : /*#__PURE__*/ React.createElement(PlayBlackButtonNewSVG, {
        id: "audio-play-click",
        sx: {
            height: isAudioPlay ? "36px" : "36px",
            width: isAudioPlay ? "36px" : "36px",
            color: systemColor.primary
        },
        onClick: function () {
            playPauseHandler();
            handleTimeFinder();
        }
    }), isSlider && /*#__PURE__*/ React.createElement(Slider, {
        value: currentTime,
        max: duration,
        onChange: seekHandler,
        style: {
            display: 'flex',
            alignSelf: 'center',
            width: '90%'
        },
        sx: {
            '& .MuiSlider-rail': {
                height: '8px',
                backgroundColor: gray
            },
            '& .MuiSlider-thumb': {
                display: 'none'
            },
            '& .MuiSlider-track': {
                height: '6px'
            },
            color: systemColor.primary,
            '& .MuiSlider-valueLabel ': {
                bgcolor: systemColor.primary
            }
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        align: "center",
        style: {
            width: '25%',
            paddingRight: audioBgColor ? '10px' : '0px'
        }
    }, showFullAudioLength ? formatTime(currentTime) : formatTime(duration))));
};
